import type { IconData } from '@stacksjs/iconify-core'

export const wrenchCircle: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M3 24a21 21 0 1 0 42 0a21 21 0 1 0-42 0\"/><path d=\"M18.402 44.246v-4.94c0-1.59-.974-2.987-2.287-3.883a13.98 13.98 0 0 1-6.112-11.568c0-4.99 2.611-9.37 6.542-11.85c1.185-.747 2.583.22 2.582 1.62c-.003 2.92.04 5.856.17 8.154c.022.399.167.78.439 1.072c.62.666 1.918 1.896 3.641 2.633c.398.17.849.17 1.247 0c1.677-.718 2.953-1.903 3.59-2.579c.306-.324.453-.756.453-1.202v-8.222c0-1.38 1.37-2.335 2.553-1.622c4.063 2.45 6.78 6.906 6.78 11.996c0 4.806-2.422 9.047-6.113 11.567c-1.312.897-2.286 2.294-2.286 3.884v4.939\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default wrenchCircle
